import { YodaColors } from 'yoda-ui/yodaTheme';

export const Tab = {
  flexGrow: 1,
  width: '33%',
  maxWidth: 'initial',
  textTransform: 'initial',
  color: `${YodaColors.textPrimary}`,
};
